import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReducerType } from '../_store';
import { Category, getBookCategories } from '../_store/slice/book-categories';

export function HeaderCategories() {
  const dispatch = useDispatch();
  const bookCategories = useSelector<ReducerType, Category>((state) => state.bookCategories);
  useEffect(() => {
    dispatch(getBookCategories());
  }, []);

  const SetSubCategory = () => {
    let rtnSubCategory: any = [];

    if (bookCategories.subCategories !== undefined) {
      for (let i = 0; i < bookCategories.subCategories.length; i++) {
        rtnSubCategory = rtnSubCategory.concat(
          <ul key={i}>
            {bookCategories.subCategories[i].map((book: any) => (
              <li key={Math.random()}>
                <Link to={`/book-categories/${book.id}/books`}>{book.name}</Link>
              </li>
            ))}
          </ul>
        );
      }
    }
    return rtnSubCategory;
  };
  return (
    <nav className="categories">
      <div className="wrapper">
        {bookCategories.categories.map((category: any) => (
          <Link to={`/book-categories/${category.id}/books`} key={Math.random()}>
            {category.name}
          </Link>
        ))}
      </div>
      <div className="sub wrapper">{SetSubCategory()}</div>
    </nav>
  );
}
